/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

import styled from '@emotion/styled'
import { Button as MuiButton, Typography } from '@mui/material'
import { spacing, SpacingProps } from '@mui/system'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

import useT from '@/i18n/useT'

interface ButtonProps extends SpacingProps {
  component?: React.ElementType
  to?: string
  target?: string
}

const Button = styled(MuiButton)<ButtonProps>(spacing)

const Wrapper = styled.div`
  text-align: center;
`

function Page500() {
  const { t } = useT()

  return (
    <Wrapper>
      <Helmet title={t('page500.helmet', 'Server Error')} />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        500
      </Typography>
      <Typography component="h2" variant="h4" align="center" gutterBottom>
        {t('page500.title', 'Something went wrong')}
      </Typography>
      <Typography
        component="h2"
        variant="subtitle1"
        align="center"
        gutterBottom
      >
        {t('page500.subtitle', 'Please try again later.')}
      </Typography>

      <Button
        component={Link}
        to="/stats"
        variant="contained"
        color="secondary"
        mt={2}
      >
        {t('page500.actions.returnToDashboard', 'Return to dashboard')}
      </Button>
    </Wrapper>
  )
}

export default Page500
